var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "roleTableList",
          rowId: _vm.rowId,
          "pager-config": _vm.pagerConfig,
          url: _vm.url,
          "other-params": {
            "filter.eq.custId": _vm.mainRowId,
          },
          columns: _vm.columns,
          "cell-click": _vm.chooseRow,
        },
        on: { returnForm: _vm.returnForm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }